import React, { useRef, useEffect, useState } from "react";
import { pure } from "recompose";
import classnames from "classnames";
import styles from "./PromotionList.scss";
import { renderHTML } from "../../utils/misc";
import constants from "../../utils/constants";
import { BookableErrorMessage } from "~/components";
import { ArrowDropDownIcon } from "../../theme/assets";
import styled from "styled-components";

const ArrowContainer = styled.div`
  text-align: end;
`;

const ArrowDropDownIconStyled = styled(ArrowDropDownIcon)`
  svg {
    width: 10px;
  }
  svg {
    path {
      fill: ${props => props.color};
    }
  }
`;

function getStatusDetails(
  statusMap,
  type,
  labelClassName,
  failedValueClassName,
  successValueClassName
) {
  if (!statusMap.get(type)) {
    return null;
  }
  return {
    status: statusMap.get(type).get("code"),
    valueType: statusMap.get(type).get("filterType"),
    value: statusMap.get(type).get("value"),
    labelClassName: labelClassName,
    valueClassName:
      statusMap.get(type).get("code") === constants.BOOKABLE_STATUS.AVAILABLE
        ? successValueClassName
        : failedValueClassName,
  };
}

const ariValueType = [
  constants.ARI_VALUE_TYPE.MIN_STAY,
  constants.ARI_VALUE_TYPE.MAX_STAY,
  constants.ARI_VALUE_TYPE.MIN_NOTICE,
  constants.ARI_VALUE_TYPE.MAX_NOTICE,
  constants.ARI_VALUE_TYPE.CONTRACT_PERIOD,
];

function hasRestrictions({ promotion }) {
  const hasErrorMessages =
    ariValueType
      .map(valueType =>
        promotion.get("status").get(valueType) &&
        promotion.get("status").get(valueType).get("value") !== null
          ? true
          : null
      )
      .filter(it => it !== null).length > 0;
  return hasErrorMessages || promotion.get("expires") || promotion.get("reduction") > 0;
}

export function PromotionDescription({ promotion, mode, styles: passedStyles, inverseTextColor }) {
  const descriptionRef = useRef(null);
  const [showScrollIcon, setShowScrollIcon] = useState(false);

  useEffect(() => {
    if (descriptionRef && descriptionRef.current && descriptionRef.current.offsetHeight > 280) {
      setShowScrollIcon(true);
    }
  }, [descriptionRef]);

  let appliedStyles = styles;
  if (passedStyles) {
    appliedStyles = passedStyles;
  }
  return (
    <>
      <div
        className={classnames(
          "wbkv9-PromotionDescription",
          appliedStyles.promotionDescription,
          mode === "tooltip" && appliedStyles.toolTip
        )}>
        <div ref={descriptionRef} className={appliedStyles.rightContainer}>
          <span dangerouslySetInnerHTML={renderHTML(promotion.get("description"))} />
        </div>
        {hasRestrictions({ promotion }) && (
          <div className={appliedStyles.leftContainer}>
            {/* We filter highlighteds */}
            {ariValueType.map(valueType => (
              <div key={valueType}>
                <BookableErrorMessage
                  {...getStatusDetails(
                    promotion.get("status"),
                    valueType,
                    appliedStyles.label,
                    appliedStyles.failed,
                    appliedStyles.passed
                  )}
                />
              </div>
            ))}
            {promotion.get("expires") && (
              <div>
                <BookableErrorMessage
                  {...getStatusDetails(
                    promotion.get("status"),
                    constants.ARI_VALUE_TYPE.VALIDITY,
                    appliedStyles.label,
                    appliedStyles.failed,
                    appliedStyles.passed
                  )}
                />
              </div>
            )}
          </div>
        )}
      </div>
      {showScrollIcon && (
        <ArrowContainer>
          <ArrowDropDownIconStyled color={inverseTextColor} />
        </ArrowContainer>
      )}
    </>
  );
}

export default pure(PromotionDescription);
